import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SessionsState } from "../../types";

const initialState: SessionsState = {
  fetchedGameSessions: false,
  fetchedPlayerSessions: false,
  gameSessions: [],
  filteredGameSessions: [],
  playerSessions: [],
  filteredPlayerSessions: [],
};

const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {
    setGameSessions: (state, action: PayloadAction<any[]>) => {
      state.gameSessions = action.payload;
      state.fetchedGameSessions = true;
    },
    setFilteredGameSessions: (state, action: PayloadAction<any[]>) => {
      state.filteredGameSessions = action.payload;
    },
    setPlayerSessions: (state, action: PayloadAction<any[]>) => {
      state.playerSessions = action.payload;
      state.fetchedPlayerSessions = true;
    },
    setFilteredPlayerSessions: (state, action: PayloadAction<any[]>) => {
      state.filteredPlayerSessions = action.payload;
    },
  },
});

export const {
  setGameSessions,
  setFilteredGameSessions,
  setPlayerSessions,
  setFilteredPlayerSessions,
} = sessionsSlice.actions;
export default sessionsSlice.reducer;
